import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  LEAD_ATTACHMENTS_REFRESH: createSagaAction('LEAD_ATTACHMENTS_REFRESH'),

  LEAD_ATTACHMENT_CREATE: createSagaAction('LEAD_ATTACHMENT_CREATE'),
  LEAD_ATTACHMENT_UPDATE: createSagaAction('LEAD_ATTACHMENT_UPDATE'),
  LEAD_ATTACHMENT_DELETE: createSagaAction('LEAD_ATTACHMENT_DELETE'),

  GET_LEAD_ATTACHMENTS: createSagaAction('GET_LEAD_ATTACHMENTS')
}

// Action Creators
export const actions = {
  leadAttachmentsRefresh: ({ next, leadId }) => ({
    type: constants.LEAD_ATTACHMENTS_REFRESH.ACTION,
    next,
    leadId
  }),

  createLeadAttachment: ({ leadId, content, file, filename, userId }) => ({
    type: constants.LEAD_ATTACHMENT_CREATE.ACTION,
    leadId,
    content,
    file,
    filename,
    userId
  }),

  updateLeadAttachment: ({ leadId, description, attachmentId, userId }) => ({
    type: constants.LEAD_ATTACHMENT_UPDATE.ACTION,
    leadId,
    description,
    attachmentId,
    userId
  }),

  deleteLeadAttachment: ({ leadId, attachmentId }) => ({
    type: constants.LEAD_ATTACHMENT_DELETE.ACTION,
    leadId,
    attachmentId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.LEAD_ATTACHMENTS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.LEAD_ATTACHMENTS_REFRESH.SUCCESS:
      return {
        ...state,
        leadAttachments: action.payload,
        loading: false
      }
    case constants.LEAD_ATTACHMENTS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.LEAD_ATTACHMENT_CREATE.ACTION:
      return { ...state, error: null, loading: true }
    case constants.LEAD_ATTACHMENT_CREATE.SUCCESS:
      return {
        uploadFinish: action.payload,
        ...state,
        loading: false
      }
    case constants.LEAD_ATTACHMENT_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_ATTACHMENT_DELETE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/leadAttachmentActions.js